(() => {
  const STOCK_ITEM_TAG = "STOCK ITEM";
  const STOCK_ITEM_FILTER = `tag:"${STOCK_ITEM_TAG}"`;

  function normalizeDisplayTerm(term = "") {
    return term.replace(STOCK_ITEM_FILTER, "").replace(/\s{2,}/g, " ").trim();
  }

  function buildSearchQuery(term = "") {
    const normalizedTerm = normalizeDisplayTerm(term);

    if (!normalizedTerm.length) {
      return STOCK_ITEM_FILTER;
    }

    return `${normalizedTerm} ${STOCK_ITEM_FILTER}`;
  }

  function buildPredictiveSearchQuery(term = "", { filterType = "", filterValue = "" } = {}) {
    const normalizedTerm = normalizeDisplayTerm(term);
    const queryParts = [];

    if (filterType && filterValue) {
      queryParts.push(`${filterType}:${filterValue}+*`);
    }

    if (normalizedTerm.length) {
      queryParts.push(normalizedTerm);
    }

    queryParts.push(STOCK_ITEM_FILTER);

    return queryParts.join(" ");
  }

  function updateSearchInputValue(input) {
    if (!input) {
      return;
    }

    const normalizedTerm = normalizeDisplayTerm(input.value);

    if (!normalizedTerm.length) {
      input.value = "";
      return;
    }

    input.value = buildSearchQuery(normalizedTerm);
  }

  function rewriteQueryLink(link) {
    if (!link) {
      return;
    }

    const href = link.getAttribute("href");

    if (!href) {
      return;
    }

    const url = new URL(href, window.location.origin);
    const currentQuery = url.searchParams.get("q");

    if (!currentQuery) {
      return;
    }

    url.searchParams.set("q", buildSearchQuery(currentQuery));
    link.href = `${url.pathname}${url.search}${url.hash}`;
  }

  function rewritePredictiveSearchQueryLinks(container) {
    if (!container) {
      return;
    }

    container.querySelectorAll("[data-stock-item-query-link]").forEach((link) => {
      rewriteQueryLink(link);
    });
  }

  function enhanceSearchForm(form) {
    if (!form || form.closest("predictive-search") || form.dataset.stockItemSearchBound === "true") {
      return;
    }

    const input = form.querySelector('input[type="search"][name="q"]');

    if (!input) {
      return;
    }

    form.dataset.stockItemSearchBound = "true";
    input.value = normalizeDisplayTerm(input.value);

    form.addEventListener("submit", () => {
      updateSearchInputValue(input);
    });
  }

  function init() {
    document.querySelectorAll("form.search[data-stock-item-search-form]").forEach((form) => {
      enhanceSearchForm(form);
    });
  }

  window.stockItemSearch = {
    buildPredictiveSearchQuery,
    buildSearchQuery,
    normalizeDisplayTerm,
    rewritePredictiveSearchQueryLinks,
    updateSearchInputValue,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
